export default __webpack_public_path__ + "static/media/word.cfee9537.svg";